export default function QRSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Title */}
        <h2 className="text-3xl font-bold text-[#111111] mb-6">
          PCの人はQRで追加
        </h2>

        {/* Description */}
        <p className="text-base text-gray-600 mb-8 leading-relaxed">
          スマホで読み取って友だち追加。追加後に役割を選べます。
        </p>

        {/* QR Code */}
        <div className="inline-block mb-8">
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="block cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/b590a48e1511e0e52125c9d462d6b117.png"
              alt="LINE QRコード"
              className="w-64 h-64 rounded-xl mx-auto"
              style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
            />
          </a>
        </div>

        {/* Section CTA */}
        <div>
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#EDD92A] text-black font-bold px-8 py-4 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 6px 16px rgba(0,0,0,0.15)' }}
          >
            LINEで先行テスター/投稿者登録（無料）
          </a>
        </div>
      </div>
    </section>
  );
}
